import {
    Container, Grid, InputAdornment, MenuItem, InputLabel, Modal, Card, TextField, Box, FormControlLabel, Checkbox, Button, Typography, Input, FormControl,
    Select, AppBar, Toolbar, Tooltip, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Divider, List, ListItem, ListItemIcon, ListItemText,
} from '@mui/material'
import React from 'react'
import { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SchoolIcon from "@mui/icons-material/School";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import SubjectIcon from "@mui/icons-material/Subject";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AssignmentCreateForm() {
    const [isMaster, setIsMaster] = useState(false);
    const [branches, setBranches] = useState([]);
    const [selectedBranchId, setSelectedBranchId] = useState(1);

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    let navigate = useNavigate();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [teachersList, setTeacherList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [selectedTeacherId, setSelectedTeacherId] = useState('');
    const [selectedClassId, setSelectedClassId] = useState('');
    const [selectedSubjectId, setSelectedSubjectId] = useState('');
    const [sectionList, setSectionList] = useState([]);
    const [subjectList, setSubjectList] = useState([]);
    const [selectedSectionId, setSelectedSectionId] = useState('');
    const [assignmentDescription, setAssignmentDescription] = useState('');
    const [assignmentDate, setAssignmentDate] = useState('');
    const [submissionDate, setSubmissionDate] = useState('');
    const [assignmentFile, setAssignmentFile] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    // Info dialog state
    const [infoOpen, setInfoOpen] = useState(false);

    const handleFileChange = (event) => {
        setAssignmentFile(event.target.files[0]);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        // Ensure day and month are two digits
        const formattedDay = day < 10 ? '0' + day : day;
        const formattedMonth = month < 10 ? '0' + month : month;

        return `${formattedDay}/${formattedMonth}/${year}`;
    };

    const fetchBranches = async () => {
        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const token = sessionStorage.getItem("token");
            const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify({}),
            });

            if (response.ok) {
                const data = await response.json();
                setBranches(data);
            } else {
                console.error("Failed to fetch branches");
            }
        } catch (error) {
            console.error("Error fetching branches:", error);
        }
    };

    useEffect(() => {
        const isMasterUser = sessionStorage.getItem("is_Master") === "true";
        setIsMaster(isMasterUser);

        if (isMasterUser) {
            fetchBranches();
        } else {
            const branchId = sessionStorage.getItem("branchId");
            setSelectedBranchId(branchId);
        }
    }, []);

    const handleReset = () => {
        // Reset all state variables to their initial values
        setSelectedTeacherId('');
        setSelectedClassId('');
        setSelectedSectionId('');
        setSelectedSubjectId('');
        setAssignmentDescription('');
        setAssignmentDate('');
        setSubmissionDate('');
        setAssignmentFile(null);
        setSuccessMessage('');
        setErrorMessage('');
    };

    // Add this constant at the top of the component, after the imports or state declarations
    const notificationUrl = "https://wsmsv1.aidigitalsec.com/api/Notifications/PostAssignmentNotification";

    // Updated handleSubmit function
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formattedAssignmentDate = formatDate(assignmentDate);
        const formattedSubmissionDate = formatDate(submissionDate);

        const formData = new FormData();
        formData.append('ClassId', selectedClassId);
        formData.append('SectionId', selectedSectionId);
        formData.append('SubjectId', selectedSubjectId);
        formData.append('TeacherId', selectedTeacherId);
        formData.append('AssignmentDescription', assignmentDescription);
        formData.append('AssignmentDate', formattedAssignmentDate);
        formData.append('AssignmentSubmitDate', formattedSubmissionDate);
        formData.append('AssignmentFile', assignmentFile);
        const branchId = isMaster
            ? selectedBranchId
            : sessionStorage.getItem("branchId");

        try {
            const url = process.env.REACT_APP_BASE_URL;
            const apiUrl = `${url}/AssignmentCreate?Branch_Id=${branchId}`;
            const token = sessionStorage.getItem('token');
            const userId = parseInt(sessionStorage.getItem("userId")) || 0;
            const clientName = sessionStorage.getItem("clientName") || "";
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    Authorization: token,
                },
                body: formData,
            });

            if (response.ok) {
                // Send notification for the successfully created assignment
                const message = `${clientName} created assignment "${assignmentDescription.substring(0, 50)}${assignmentDescription.length > 50 ? '...' : ''}"`;
                const notifBody = {
                    userId,
                    message,
                    name: clientName
                };

                await fetch(notificationUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: token,
                    },
                    body: JSON.stringify(notifBody),
                }).catch((err) => {
                    console.error("Notification API Error:", err);
                });

                // Handle successful response
                console.log('Assignment created successfully');
                // Clear form fields and show success message
                clearForm();
                setShowSuccessModal(true);
            } else {
                // Handle error response
                console.error('Failed to create assignment');
                setErrorMessage('Failed to create assignment');
                setSnackbarMessage('Failed to create assignment');
                setOpenSnackbar(true);
                setSnackbarSeverity("error");
            }
        } catch (error) {
            console.error('API request error:', error);
            setSnackbarMessage('API request error');
            setOpenSnackbar(true);
            setSnackbarSeverity("error");
        }
    };

    const clearForm = () => {
        setSelectedClassId('');
        setSelectedSectionId('');
        setSelectedSubjectId('');
        setSelectedTeacherId('');
        setAssignmentDescription('');
        setAssignmentDate('');
        setSubmissionDate('');
        setAssignmentFile(null);
    };

    const fetchTeachers = async () => {
        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const token = sessionStorage.getItem('token');
            const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");

            const response = await fetch(`${apiUrl}/AssignmentCreate/GetTeacher?Branch_Id=${branchId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({}),
            });

            if (!response.ok) {
                throw new Error(`Error fetching teachers: ${response.status}`);
            }
            const data = await response.json();
            if (data.data === null && data.msg === "Record Not Found") {
                setTeacherList([]);
                return;
            }
            // Handle both array and object responses
            const teachers = Array.isArray(data) ? data : (data.data || []);
            setTeacherList(teachers);
        } catch (error) {
            console.error(error);
            setTeacherList([]);
        }
    };

    const fetchClasses = async (teacherId) => {
        try {
            // Reset dependent dropdowns when teacher changes
            setClassList([]);
            setSectionList([]);
            setSubjectList([]);
            setSelectedClassId('');
            setSelectedSectionId('');
            setSelectedSubjectId('');

            if (!teacherId) {
                return;
            }

            const apiUrl = process.env.REACT_APP_BASE_URL;
            const token = sessionStorage.getItem('token');
            const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");

            const response = await fetch(`${apiUrl}/AssignmentCreate/GetClass?Branch_Id=${branchId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({ teacherId }),
            });

            if (!response.ok) {
                throw new Error(`Error fetching classes: ${response.status}`);
            }
            const data = await response.json();
            if (data.data === null && data.msg === "Record Not Found") {
                setClassList([]);
                return;
            }
            // Handle both array and object responses
            const classes = Array.isArray(data) ? data : (data.data || []);
            setClassList(classes);
        } catch (error) {
            console.error(error);
            setClassList([]);
        }
    };

    const fetchSections = async (classId, teacherId) => {
        try {
            // Reset dependent dropdowns
            setSectionList([]);
            setSubjectList([]);
            setSelectedSectionId('');
            setSelectedSubjectId('');

            if (!classId || !teacherId) {
                return;
            }

            const apiUrl = process.env.REACT_APP_BASE_URL;
            const token = sessionStorage.getItem('token');
            const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");

            const response = await fetch(`${apiUrl}/AssignmentCreate/ddlSection_clsId?Branch_Id=${branchId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({ classId, teacherId }),
            });

            if (!response.ok) {
                throw new Error(`Error fetching sections: ${response.status}`);
            }
            const data = await response.json();
            if (data.data === null && data.msg === "Record Not Found") {
                setSectionList([]);
                return;
            }
            // Handle both array and object responses
            const sections = Array.isArray(data) ? data : (data.data || []);
            setSectionList(sections);
        } catch (error) {
            console.error(error);
            setSectionList([]);
        }
    };

    const fetchSubject = async (classId, teacherId, sectionId) => {
        try {
            // Reset subject dropdown
            setSubjectList([]);
            setSelectedSubjectId('');

            if (!classId || !teacherId || !sectionId) {
                return;
            }

            const apiUrl = process.env.REACT_APP_BASE_URL;
            const token = sessionStorage.getItem('token');
            const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");

            const response = await fetch(`${apiUrl}/AssignmentCreate/Subjectddl?Branch_Id=${branchId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({ classId, teacherId, sectionId }),
            });

            if (!response.ok) {
                throw new Error(`Error fetching subjects: ${response.status}`);
            }
            const data = await response.json();
            if (data.data === null && data.msg === "Record Not Found") {
                setSubjectList([]);
                return;
            }
            // Handle both array and object responses
            const subjects = Array.isArray(data) ? data : (data.data || []);
            setSubjectList(subjects);
        } catch (error) {
            console.error(error);
            setSubjectList([]);
        }
    };

    useEffect(() => {
        if (selectedBranchId) {
            fetchTeachers();
        }
    }, [selectedBranchId]);

    useEffect(() => {
        fetchTeachers();
    }, []);

    useEffect(() => {
        fetchClasses(selectedTeacherId);
    }, [selectedTeacherId]);

    useEffect(() => {
        fetchSections(selectedClassId, selectedTeacherId);
    }, [selectedClassId, selectedTeacherId]);

    useEffect(() => {
        fetchSubject(selectedClassId, selectedTeacherId, selectedSectionId);
    }, [selectedClassId, selectedTeacherId, selectedSectionId]);

    useEffect(() => {
        const today = new Date();
        const sevenDaysLater = new Date();
        sevenDaysLater.setDate(today.getDate() + 7);

        const formatToInputDate = (date) => {
            const year = date.getFullYear();
            const month = (`0${date.getMonth() + 1}`).slice(-2);
            const day = (`0${date.getDate()}`).slice(-2);
            return `${year}-${month}-${day}`;
        };

        setAssignmentDate(formatToInputDate(today));
        setSubmissionDate(formatToInputDate(sevenDaysLater));
    }, []);

    useEffect(() => {
        if (!assignmentDate) return;

        const assignment = new Date(assignmentDate);
        assignment.setDate(assignment.getDate() + 7);

        const formatToInputDate = (date) => {
            const year = date.getFullYear();
            const month = (`0${date.getMonth() + 1}`).slice(-2);
            const day = (`0${date.getDate()}`).slice(-2);
            return `${year}-${month}-${day}`;
        };

        setSubmissionDate(formatToInputDate(assignment));
    }, [assignmentDate]);

    return (
        <Container>
            <AppBar
                position="static"
                sx={{
                    backgroundColor: "#0B1F3D",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                }}
            >
                <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3 }}>

                    {/* Left: Title + Info Button */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 700,
                                letterSpacing: "0.5px",
                                color: "#ffffff",
                            }}
                        >
                            Create Assignment
                        </Typography>

                        {/* ── Info Button ── */}
                        <Tooltip title="About this form" arrow>
                            <IconButton
                                onClick={() => setInfoOpen(true)}
                                size="small"
                                sx={{
                                    color: "rgba(255,255,255,0.75)",
                                    border: "1.5px solid rgba(255,255,255,0.35)",
                                    borderRadius: "50%",
                                    width: 30,
                                    height: 30,
                                    ml: 0.5,
                                    transition: "all 0.2s ease",
                                    "&:hover": {
                                        color: "#ffffff",
                                        backgroundColor: "rgba(100,181,246,0.2)",
                                        borderColor: "#64B5F6",
                                        transform: "scale(1.1)",
                                        boxShadow: "0 0 8px rgba(100,181,246,0.4)",
                                    },
                                }}
                            >
                                <InfoOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    {/* Right: Branch Dropdown */}
                    {isMaster && (
                        <Box sx={{ position: "relative" }}>
                            <FormControl size="small" sx={{ width: 220 }}>
                                <InputLabel
                                    sx={{
                                        color: "rgba(255,255,255,0.6)",
                                        fontSize: "0.75rem",
                                        fontWeight: 500,
                                        letterSpacing: "0.6px",
                                        textTransform: "uppercase",
                                        top: "-2px",
                                        "&.Mui-focused": { color: "#64B5F6" },
                                        "&.MuiFormLabel-filled": { color: "rgba(255,255,255,0.7)" },
                                    }}
                                >
                                    Branch
                                </InputLabel>
                                <Select
                                    value={selectedBranchId || ""}
                                    onChange={(e) => setSelectedBranchId(e.target.value)}
                                    label="Branch"
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <LocationOnIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.5)", ml: 0.5 }} />
                                        </InputAdornment>
                                    }
                                    sx={{
                                        color: "#ffffff",
                                        fontWeight: 500,
                                        fontSize: "0.875rem",
                                        letterSpacing: "0.3px",
                                        backgroundColor: "rgba(255,255,255,0.07)",
                                        backdropFilter: "blur(8px)",
                                        borderRadius: "8px",
                                        transition: "background-color 0.2s ease, box-shadow 0.2s ease",
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "rgba(255,255,255,0.15)",
                                            borderWidth: "1px",
                                            transition: "border-color 0.2s ease",
                                        },
                                        "&:hover": {
                                            backgroundColor: "rgba(255,255,255,0.11)",
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "rgba(255,255,255,0.35)",
                                            },
                                        },
                                        "&.Mui-focused": {
                                            backgroundColor: "rgba(255,255,255,0.1)",
                                            boxShadow: "0 0 0 3px rgba(100,181,246,0.18)",
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "#64B5F6",
                                                borderWidth: "1.5px",
                                            },
                                        },
                                        "& .MuiSelect-icon": {
                                            color: "rgba(255,255,255,0.5)",
                                            transition: "color 0.2s ease",
                                        },
                                        "&.Mui-focused .MuiSelect-icon": {
                                            color: "#64B5F6",
                                        },
                                        "& .MuiSelect-select": {
                                            py: 1.1,
                                        },
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                mt: 0.5,
                                                borderRadius: "10px",
                                                border: "1px solid rgba(11,31,61,0.12)",
                                                boxShadow: "0 8px 32px rgba(11,31,61,0.18), 0 2px 8px rgba(0,0,0,0.08)",
                                                overflow: "hidden",
                                                "& .MuiList-root": { py: 0.5 },
                                            },
                                        },
                                    }}
                                >
                                    {branches.map((branch) => (
                                        <MenuItem
                                            key={branch.branchId}
                                            value={branch.branchId}
                                            sx={{
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                color: "#0B1F3D",
                                                px: 2,
                                                py: 1.1,
                                                mx: 0.5,
                                                borderRadius: "6px",
                                                transition: "background-color 0.15s ease",
                                                "&:hover": {
                                                    backgroundColor: "rgba(11,31,61,0.07)",
                                                },
                                                "&.Mui-selected": {
                                                    backgroundColor: "rgba(25,118,210,0.1)",
                                                    color: "#1565C0",
                                                    fontWeight: 600,
                                                    "&:hover": {
                                                        backgroundColor: "rgba(25,118,210,0.15)",
                                                    },
                                                },
                                            }}
                                        >
                                            {branch.branchName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    )}
                </Toolbar>
            </AppBar>

            <Card className="card-body" style={{ marginTop: 6 }}>
                <Box
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Container className="mt-3">
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item md={6} >
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="teacher" required>Teacher</InputLabel>
                                        <Select
                                            labelId="teacher-label"
                                            id="teacher-select"
                                            label="Teacher"
                                            value={selectedTeacherId}
                                            onChange={(e) => setSelectedTeacherId(e.target.value)}
                                        >
                                            {/* Populate with teacher options */}
                                            {Array.isArray(teachersList) && teachersList.map((item) => (
                                                <MenuItem key={item.employeeId} value={item.employeeId}>
                                                    {item.employeeName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth style={{ marginTop: "15px" }}>
                                        <InputLabel htmlFor="section" required>Section</InputLabel>
                                        <Select
                                            labelId="section-label"
                                            id="section-select"
                                            value={selectedSectionId}
                                            onChange={(e) => setSelectedSectionId(e.target.value)}
                                            label="Section"
                                        >
                                            {/* Populate with section options */}
                                            {Array.isArray(sectionList) && sectionList.length > 0 ? (
                                                sectionList.map((sectionItem) => (
                                                    <MenuItem key={sectionItem.sectionId} value={sectionItem.sectionId}>
                                                        {sectionItem.sectionName}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem value="">No sections found</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth style={{ marginTop: "15px" }}>
                                        <InputLabel htmlFor="subject" required>Subject</InputLabel>
                                        <Select
                                            labelId="subject-label"
                                            id="subject-select"
                                            label="Subject"
                                            value={selectedSubjectId}
                                            onChange={(e) => setSelectedSubjectId(e.target.value)}
                                        >
                                            {Array.isArray(subjectList) && subjectList.map((item) => (
                                                <MenuItem key={item.subjectId} value={item.subjectId}>
                                                    {item.subjectName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item md={6}>
                                    <FormControl fullWidth >
                                        <InputLabel htmlFor="Class">Class</InputLabel>
                                        <Select
                                            labelId="class-label"
                                            id="class-select"
                                            value={selectedClassId}
                                            onChange={(e) => setSelectedClassId(e.target.value)}
                                            label="Class"
                                        >
                                            {/* Populate with class options */}
                                            {Array.isArray(classList) && classList.map((classItem) => (
                                                <MenuItem key={classItem.classId} value={classItem.classId}>
                                                    {classItem.className}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <TextField
                                        id="assignment-description"
                                        label="Assignment Description"
                                        multiline
                                        rows={3}
                                        fullWidth
                                        style={{ marginTop: "15px" }}
                                        value={assignmentDescription}
                                        onChange={(e) => setAssignmentDescription(e.target.value)}
                                    />
                                </Grid>
                                <Grid item md={6} >
                                    <TextField
                                        id="assignment-date"
                                        label="Assignment Date"
                                        type="date"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={assignmentDate}
                                        onChange={(e) => setAssignmentDate(e.target.value)}
                                    />
                                </Grid>
                                <Grid item md={6} style={{ marginTop: "1px" }} >
                                    <TextField
                                        id="submission-date"
                                        label="Submission Date"
                                        type="date"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={submissionDate}
                                        onChange={(e) => setSubmissionDate(e.target.value)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={3} mt={2}>
                                <Grid item xs={6}>
                                    <Grid container direction="column">
                                        <Grid item>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Upload Assignment
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item>
                                <form>
                                    <Box className="form-group">
                                        <Typography variant="subtitle1" gutterBottom></Typography>
                                        <Input type="file" onChange={handleFileChange} />
                                    </Box>
                                </form>
                            </Grid>
                        </form>
                    </Container>
                </Box>
            </Card>

            <Grid container justifyContent="end" alignItems="center">
                <Button variant="contained" type="submit" onClick={handleSubmit}
                    color="primary"
                    style={{
                        width: "90px",
                        height: "50px",
                        padding: "10px 0",
                        fontWeight: 'bold',
                        marginTop: 16,
                        marginRight: 7
                    }}
                >
                    SAVE
                </Button>
                <Button variant="contained" type="submit" onClick={handleReset}
                    color="error"
                    style={{
                        width: "90px",
                        height: "50px",
                        padding: "10px 0",
                        fontWeight: 'bold',
                        marginTop: 16
                    }}
                >
                    RESET
                </Button>
            </Grid>

            {/* Success Modal */}
            <Modal
                open={showSuccessModal}
                onClose={() => setShowSuccessModal(false)}
                aria-labelledby="success-modal-title"
                aria-describedby="success-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        overflow: 'hidden',
                    }}
                >
                    {/* Header */}
                    <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
                        <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
                            Assignment Created ✅
                        </Typography>
                    </Box>

                    {/* Content */}
                    <Box sx={{ padding: '20px' }}>
                        <Typography id="success-modal-description" sx={{ mb: 2 }}>
                            The Assignment has been created successfully.
                        </Typography>

                        {/* Buttons */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                            <Button
                                onClick={() => {
                                    setShowSuccessModal(false);
                                    navigate(-1); // go back after closing modal
                                }}
                                variant="contained"
                                color="primary"
                            >
                                OK
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={4000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>

            {/* ── Info Dialog ── */}
            <Dialog
                open={infoOpen}
                onClose={() => setInfoOpen(false)}
                maxWidth="sm"
                fullWidth
                sx={{
                    "& .MuiDialog-paper": {
                        borderRadius: "16px",
                        boxShadow: "0 12px 40px rgba(11,31,61,0.2)",
                        overflow: "hidden",
                    },
                }}
            >
                {/* Header */}
                <DialogTitle
                    sx={{
                        background: "linear-gradient(135deg, #0B1F3D 0%, #1565C0 100%)",
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "1.2rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: 3,
                        py: 2,
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <InfoOutlinedIcon sx={{ fontSize: 22 }} />
                        Create Assignment — Form Guide
                    </Box>
                    
                </DialogTitle>

                <DialogContent sx={{ px: 3, py: 2.5 }}>

                    {/* Purpose */}
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.7 }}>
                        Use this form to create a new assignment for students. Select the teacher, class,
                        section, and subject, enter the assignment details, set the dates, optionally
                        attach a file, and click Save to publish the assignment.
                    </Typography>

                    <Divider sx={{ mb: 2 }} />

                    {/* Fields */}
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.2, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
                        Field Reference
                    </Typography>

                    <List dense disablePadding>

                        <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                                <PersonOutlineIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<Typography variant="body2" fontWeight={600}>Teacher <span style={{ color: "red" }}>*</span></Typography>}
                                secondary="Select the teacher creating this assignment. This loads the classes assigned to that teacher."
                            />
                        </ListItem>

                        <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                                <SchoolIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<Typography variant="body2" fontWeight={600}>Class</Typography>}
                                secondary="Select the class for which this assignment is intended. Changing the class resets the Section and Subject dropdowns."
                            />
                        </ListItem>

                        <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                                <MeetingRoomOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<Typography variant="body2" fontWeight={600}>Section <span style={{ color: "red" }}>*</span></Typography>}
                                secondary="Select the section within the class. Loaded based on the selected Teacher + Class combination."
                            />
                        </ListItem>

                        <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                                <SubjectIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<Typography variant="body2" fontWeight={600}>Subject <span style={{ color: "red" }}>*</span></Typography>}
                                secondary="Select the subject for the assignment. Loaded based on the selected Teacher + Class + Section combination."
                            />
                        </ListItem>

                        <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                                <ArticleOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<Typography variant="body2" fontWeight={600}>Assignment Description</Typography>}
                                secondary="Enter the details or instructions for the assignment. Supports multiple lines of text."
                            />
                        </ListItem>

                        <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                                <CalendarTodayIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<Typography variant="body2" fontWeight={600}>Assignment Date</Typography>}
                                secondary="The date the assignment is given. Defaults to today. Changing this date automatically updates the Submission Date to 7 days later."
                            />
                        </ListItem>

                        <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                                <EventAvailableIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<Typography variant="body2" fontWeight={600}>Submission Date</Typography>}
                                secondary="The deadline for submitting the assignment. Auto-set to 7 days after the Assignment Date but can be changed manually."
                            />
                        </ListItem>

                        <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                                <UploadFileOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<Typography variant="body2" fontWeight={600}>Upload Assignment (File)</Typography>}
                                secondary="Optional. Attach a file for the assignment (e.g. question paper, worksheet). Any file type is accepted."
                            />
                        </ListItem>

                        {isMaster && (
                            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                                <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                                    <LocationOnIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={<Typography variant="body2" fontWeight={600}>Branch (Master Only)</Typography>}
                                    secondary="Select a branch from the top-right dropdown. All dropdowns reload based on the selected branch."
                                />
                            </ListItem>
                        )}

                    </List>

                    <Divider sx={{ my: 2 }} />

                    {/* Buttons */}
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
                        Buttons
                    </Typography>
                    <List dense disablePadding>
                        <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                                <SaveOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<Typography variant="body2" fontWeight={600}>Save</Typography>}
                                secondary="Submits the assignment and sends a notification. On success, a confirmation modal appears and the form clears; clicking OK navigates back."
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                                <RestartAltIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<Typography variant="body2" fontWeight={600}>Reset</Typography>}
                                secondary="Clears all form fields without navigating away, allowing you to start over."
                            />
                        </ListItem>
                    </List>

                    <Divider sx={{ my: 2 }} />

                    {/* Important notes */}
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
                        Important Notes
                    </Typography>
                    <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
                        {[
                            "Teacher → Class → Section → Subject is a cascading chain; each selection loads the next dropdown.",
                            "Changing the Teacher resets Class, Section, and Subject.",
                            "Changing the Class resets Section and Subject.",
                            "Submission Date auto-updates to 7 days after the Assignment Date when the date is changed.",
                            "A push notification is automatically sent to users after a successful save.",
                            "File upload is optional — the assignment can be saved without an attachment.",
                            "After a successful save the form clears automatically.",
                        ].map((note, i) => (
                            <Typography key={i} component="li" variant="body2" color="text.secondary" sx={{ mb: 0.5, lineHeight: 1.6 }}>
                                {note}
                            </Typography>
                        ))}
                    </Box>

                </DialogContent>

                <DialogActions sx={{ backgroundColor: "#f5f5f5", px: 3, py: 2 }}>
                    <Button
                        onClick={() => setInfoOpen(false)}
                        variant="contained"
                        sx={{
                            backgroundColor: "#0B1F3D",
                            color: "#fff",
                            borderRadius: "8px",
                            fontWeight: 600,
                            "&:hover": { backgroundColor: "#1565C0" },
                        }}
                    >
                        Got it
                    </Button>
                </DialogActions>
            </Dialog>
            {/* ── End Info Dialog ── */}

        </Container>
    );
}

export default AssignmentCreateForm;